import { Component, Input, OnInit } from '@angular/core';
import {
  ApiError,
  GenericApiResponse,
  UserPostcodePricingResponse,
} from 'src/app/interfaces/api';
import { IBanner } from 'src/app/interfaces/strapi';
import { UserService } from 'src/app/services/user.service';
import { NgIf, CurrencyPipe } from '@angular/common';
import { AuthService } from '../../../services/auth.service';
import { AnalyticsService } from '../../../services/analytics.service';

enum StudentGuardBannerEnum {
  priceStringReplace = '<price>',
  uniStringReplace = '<university-name>',
}

@Component({
    selector: 'app-student-guard-banner',
    templateUrl: './student-guard-banner.component.html',
    styleUrls: ['./student-guard-banner.component.scss'],
    imports: [NgIf, CurrencyPipe],
})
export class StudentGuardBannerComponent implements OnInit {
  @Input() banner: IBanner | undefined = {} as IBanner;

  public StudentGuardBannerEnum = StudentGuardBannerEnum;

  public userPricing: string = '';

  public isLoading: boolean = false;

  public pricingRetrievalError: boolean = false;

  constructor(
    private readonly auth: AuthService,
    private readonly user: UserService,
    private readonly analyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {
    if (!this.auth.currentUser) return;
    this.isLoading = true;
    this.user.getPriceBasedOnPostcode(this.auth.currentUser).subscribe({
      next: (data: GenericApiResponse<UserPostcodePricingResponse>) => {
        this.userPricing = data.data.pricing;
        if (this.checkStringReplaceValue && this.banner?.excerpt) {
          this.banner.excerpt = this.getUpdatedBannerExcerpt(this.userPricing);
        }
      },
      error: (_err: ApiError) => {
        this.pricingRetrievalError = true;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  /**
   * check if the logo is an avg
   * @returns boolean
   */
  public get checkIsSvg(): boolean {
    return this.banner?.image?.data.attributes.url?.includes('.svg') ?? false;
  }

  /**
   * make sure that both replaceable text is in the excerpt
   * @returns boolean
   */
  public get checkStringReplaceValue(): boolean {
    if (!this.banner?.excerpt) return false;
    const excerpt = this.banner?.excerpt;
    return (
      excerpt.includes(StudentGuardBannerEnum.priceStringReplace) &&
      excerpt.includes(StudentGuardBannerEnum.uniStringReplace)
    );
  }

  /**
   * String replace the excerpt with the student guard price and university name
   * @param price
   * @returns string
   */
  public getUpdatedBannerExcerpt(price: string): string {
    const uniName = this.auth.currentUser?.university.name;
    if (!uniName) return '';
    return (
      this.banner?.excerpt
        ?.replaceAll(StudentGuardBannerEnum.priceStringReplace, `£${price}`)
        .replaceAll(StudentGuardBannerEnum.uniStringReplace, uniName) ?? ''
    );
  }

  public trackEvent() {
    this.analyticsService.trackEvent('student_guard_button_clicked', {
      source: 'WEB',
      universityUUID: this.auth.currentUser?.university.cmsId,
    });
  }
}
